import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';



@Injectable()
export class TriBulletinService {

  private endpointURL = 'tri-bulletin/all';
  private endpointURL_newBulletins = 'tri-bulletin/new';

  private serviceBulletinFilter: string;

  constructor(private http: HttpClient) { }

  /** GET Bulletin from the server */

  getAllTriBulletinService(): Observable<any> {
    return this.http.get(this.endpointURL,{withCredentials : true});
  }

  getNewTriBulletinService(): Observable<any> {
    return this.http.get(this.endpointURL_newBulletins,{withCredentials : true});
  }

  // get user's history of TRI Bulletins

  getHistoryTriBulletinService(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/triHistorylist`,{withCredentials : true});
  }

  // add user visited bulletin to his history
  addBulletinToUserHistory(userId, id) {
    return this.http.post(`user-info/qID/${userId}/addTRIToHistorylist/${id}`, '',{withCredentials : true});
  }

  // fetch user saved TRI bulletins
  getUserSavedTRIBulletins(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/tri/userSavedBulletinGroupCategory`,{withCredentials : true});
  }

  saveFilterData(filter: string) {
    this.serviceBulletinFilter = filter;
  }

  getFilterData(): string {
    return this.serviceBulletinFilter;
  }
}
